// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0653cdb4] svg#fee-info,[data-v-0653cdb4] svg#replacement-tag-fee-info{opacity:.85}", ""]);
// Exports
module.exports = exports;
